import React from 'react'

import LinkButton, { LinkButtonProp, LinkButtonRegisterProps } from 'components/ui-builder/common/button'

import RightRecipeArrow from '../../../../images/recipes/recipe-right-arrow.svg'

import './recipe.css'

interface IFoodCharacteristics {
  iconImg: any
  characteristic: string
}

export interface ICreatePlan {
  backgroundColor: string
  createPlanImage: any
  createPlanImageBG: string
  createPlanTitle: string
  createPlanTitleColor: string
  // createPlanArrow: any;
  createPlanSummary: string
  createPlanSummaryColor: string
  foodCharacteristics: IFoodCharacteristics[]
  buttonProps: LinkButtonProp
}

const CreatePlan = ({
  backgroundColor,
  createPlanImage,
  createPlanImageBG,
  createPlanTitle,
  createPlanTitleColor,
  // createPlanArrow,
  createPlanSummary,
  createPlanSummaryColor,
  foodCharacteristics,
  buttonProps
}: ICreatePlan) => {
  console.log('CREATE PLAN DATA', foodCharacteristics)

  const renderFoodCharacteristics = () => {
    if (!foodCharacteristics) return null
    return foodCharacteristics.map((foodItem: IFoodCharacteristics, i: number) => {
      return (
        <div
          className="flex w-full items-start justify-center p-2 sm:my-0 sm:mx-auto sm:w-10/12"
          key={`${foodItem.characteristic}-${i}`}
        >
          <img src={foodItem.iconImg} alt={foodItem.characteristic} className="food-char-img object-contain" />
          <div className="food-char-char flex flex-col justify-center pl-2">
            <p className="text-base">{foodItem.characteristic}</p>
          </div>
        </div>
      )
    })
  }

  const renderButton = (classList?: string) => {
    buttonProps = buttonProps || {}
    return (
      <LinkButton
        buttonColor={buttonProps.buttonColor}
        buttonText={buttonProps.buttonText}
        buttonTextColor={buttonProps.buttonTextColor}
        loggedInButtonText={buttonProps.loggedInButtonText}
        buttonUrl={buttonProps.buttonUrl}
        isLink={buttonProps.isLink}
        classList={
          classList ||
          'inline-block bg-white py-2 px-4 border border-transparent rounded-full text-base font-medium text-indigo-600 hover:bg-indigo-50 shadow'
        }
      />
    )
  }

  return (
    <div className="w-full py-8" style={{ backgroundColor }}>
      {/* desktop ui */}
      <div className="container mx-auto hidden sm:flex">
        <div className="create-plan-container mx-auto flex">
          <div className="w-2/5">
            <div className="create-plan-desktop-img-wrap w-11/12" style={{ backgroundColor: createPlanImageBG }}>
              <img
                className="absolute -top-2 -right-1 h-full w-11/12 object-cover"
                src={createPlanImage}
                alt="mainText"
              />
            </div>
          </div>
          <div className="w-3/5 p-2 pt-14">
            <div className="relative flex w-full flex-col items-center">
              <div className="relative w-10/12 text-right">
                <h1 className="w-full leading-8" id="recipe-create-plan-title" style={{ color: createPlanTitleColor }}>
                  {createPlanTitle}
                </h1>
                <img className="create-plan-arrow absolute" src={RightRecipeArrow} />
              </div>
              <div className="w-10/12 text-right">
                <h3 className="w-full pr-6 pt-6" style={{ color: createPlanSummaryColor }}>
                  {createPlanSummary}
                </h3>
              </div>
            </div>

            <div className="w-full pt-4">{renderFoodCharacteristics()}</div>

            <div className="pt-4 text-center">{renderButton()}</div>
          </div>
        </div>
      </div>

      {/* mobile ui */}
      <div className="container block sm:hidden">
        <div className="flex w-full">
          <div className="w-2/5">
            <div className="create-plan-desktop-img-wrap" style={{ backgroundColor: createPlanImageBG }}>
              <img
                className="absolute -top-2 -right-1 h-full w-11/12 object-cover"
                src={createPlanImage}
                alt="mainText"
              />
            </div>
          </div>
          <div className="w-3/5">
            <div className="relative flex w-full flex-col">
              <div className="relative w-10/12 text-right">
                <h2 className="create-plan-mobile-title w-full" style={{ color: createPlanTitleColor }}>
                  {createPlanTitle}
                </h2>
                <img className="create-plan-arrow absolute" src={RightRecipeArrow} />
              </div>
              <div className="w-10/12 text-right">
                <h3 className="create-plan-mobile-summary w-full pr-6 pt-6" style={{ color: createPlanSummaryColor }}>
                  {createPlanSummary}
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full pt-4">{renderFoodCharacteristics()}</div>
        <div className="p-2 pt-4 text-center">
          {renderButton(
            'inline-block bg-white py-2 px-4 border border-transparent rounded-full text-base font-medium text-indigo-600 hover:bg-indigo-50 shadow w-full'
          )}
        </div>
      </div>
    </div>
  )
}

export default CreatePlan

export const CreatePlanProps = {
  name: 'createPlanProps',
  type: 'object',
  defaultValue: {
    showCreatePlan: true,
    backgroundColor: '#004355',
    createPlanImage: null,
    createPlanImageBG: 'blue',
    createPlanTitle: '',
    createPlanTitleColor: 'black',
    // createPlanArrow: null,
    createPlanSummary: '',
    createPlanSummaryColor: 'orange',
    foodCharacteristics: [],
    buttonProps: {}
  },
  subFields: [
    { name: 'showCreatePlan', type: 'boolean', defaultValue: true },
    { name: 'backgroundColor', type: 'color', defaultValue: '#004355' },
    { name: 'createPlanImage', type: 'file', defaultValue: null },
    { name: 'createPlanImageBG', type: 'color', defaultValue: 'blue' },
    { name: 'createPlanTitle', type: 'text', defaultValue: 'Why Braised Beef works for Minnie' },
    { name: 'createPlanTitleColor', type: 'color', defaultValue: 'black' },
    // { name: 'createPlanArrow', type: 'file', defaultValue: null },
    { name: 'createPlanSummary', type: 'text', defaultValue: '3 year old Spaniel' },
    { name: 'createPlanSummaryColor', type: 'color', defaultValue: 'orange' },
    {
      name: 'foodCharacteristics',
      type: 'list',
      defaultValue: [
        {
          iconImg: null,
          characteristic: 'Fresh food, grown in the UK and delivered straight to your door'
        }
      ],
      subFields: [
        { name: 'iconImg', type: 'file', defaultValue: null },
        {
          name: 'characteristic',
          type: 'text',
          defaultValue: 'Fresh food, grown in the UK and delivered straight to your door'
        }
      ]
    },
    {
      ...LinkButtonRegisterProps
    }
  ]
}
